import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { FC } from '../../Services/FeathersClient'
import { Flex, Spinner, Text } from '../../Components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { columnProps } from '../../Services/Functions'

export const ViewSollecito = () => {
  const { idSollecito } = useParams()
  const [sollecito, setSollecito] = useState(null)
  const [emails, setEmails] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        const s = await FC.service('solleciti').get(idSollecito)
        if (!mounted) return
        setSollecito(s)
        const es = await FC.service('sollecitiEmail').find({ query: { sollecitoId: idSollecito, $sort: { id: -1 } } })
        const data = Array.isArray(es) ? es : es.data || []
        setEmails(data?.map(e => ({
          ...e,
          success: e.success ? 'OK' : 'KO',
          ...(e.sentAt && { sentAt: new Date(e.sentAt).toLocaleString('it-IT') })
        })))
      } catch (e) {
        console.error('Failed to load sollecito', e)
      } finally {
        mounted && setLoading(false)
      }
    }
    load()
    return () => { mounted = false }
  }, [idSollecito])

  if (loading) return <Spinner />

  return (
    <Flex fw>
      <Text value={`Sollecito #${idSollecito}`} size={20} bold />
      <div style={{ marginTop: 8, width: '100%' }}>
        <Text value='Titolo' bold />
        <div style={{ marginTop: 6 }}>
          <Text value={sollecito?.title || ''} />
        </div>
      </div>
      <div style={{ marginTop: 12, width: '100%' }}>
        <Text value='Testo email' bold />
        <div
          style={{
            whiteSpace: 'pre-wrap',
            marginTop: 8,
            padding: 16,
            border: '1px solid #eee',
            width: '100%',
            fontSize: '16px',
            lineHeight: '1.6'
          }}
        >
          {sollecito?.emailText}
        </div>
      </div>

      <div style={{ marginTop: 20, width: '100%' }}>
        <Flex as row js>
          <Text value='Invii' bold style={{ marginRight: 8 }} />
          <Text value={`(${emails.length} email)`} style={{ fontSize: '14px' }} />
        </Flex>
        <div style={{ marginTop: 8 }}>
          <DataTable
            className='TableSignatures' filterDisplay='row' sortField='createdAt' sortOrder={-1}
            value={emails} paginator rows={10} emptyMessage='Nessuna email trovata' responsiveLayout='scroll'
          >
            <Column {...columnProps('Destinatario')} field='recipient' />
            <Column {...columnProps('Voucher')} field='voucher' />
            <Column {...columnProps('Pax')} field='pax' />
            <Column {...columnProps('Rif.')} field='riferimento' />
            <Column {...columnProps('CheckIn')} field='checkIn' />
            <Column {...columnProps('Inviato')} field='success' />
            <Column {...columnProps('Data/Ora')} field='sentAt' />
            <Column {...columnProps('Errore')} field='errorMessage' />
          </DataTable>
        </div>
      </div>
    </Flex>
  )
}

export default ViewSollecito
